import { render, staticRenderFns } from "./finger3.vue?vue&type=template&id=bc838e5a&"
import script from "./finger3.vue?vue&type=script&lang=js&"
export * from "./finger3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports